import React, { useState, useEffect } from "react";
import {
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  Button,
  Grid,
  Stack,
  TextField,
  Select,
} from "@mui/material";
import Close from "../../assets/icons/Close.svg";
import moment from "moment";
import "./ChecklistModel.css";
import { useDispatch, useSelector } from "react-redux";
import { getChecklistQuestionAnswerList } from "../../redux/actions/checklistAction";
import CircularProgress from "@mui/material/CircularProgress";
import GenerateChecklistId from "../../utils/GenerateChecklist";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
  height: "54rem",
  overflowY: "auto",
  "@media (max-width: 1440px)": {
    width: "92%",
    height: "80vh",
  },
};

const labelstyle = {
  fontSize: "14px",
  fontWeight: "600",
  color: "#464E5F",
};

const inputStyle = {
  fontSize: "14px",
  fontWeight: "400",
  color: "#464E5F",
  marginLeft: "5px",
};

const ChecklistViewModel = (Props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state?.user?.isLoading);

  const checklisQuestiontAnswerData = useSelector(
    (state) => state?.checklist?.checklisQuestiontAnswerData
  );
  const currentYear = new Date().getFullYear();

  const buttonStyles = {
    OK: {
      border: "1px solid #E9F1ED",
      fontSize: "15px",
      fontWeight: 600,
      width: "6rem",
      backgroundColor: "#E9F1ED",
      borderRadius: "10px",
      textTransform: "capitalize",
      color: "#26875C",
      ":hover": {
        backgroundColor: "#E9F1ED",
      },
    },
    Okay: {
      border: "1px solid #E9F1ED",
      fontSize: "15px",
      fontWeight: 600,
      width: "6rem",
      backgroundColor: "#E9F1ED",
      borderRadius: "10px",
      textTransform: "capitalize",
      color: "#26875C",
      ":hover": {
        backgroundColor: "#E9F1ED",
      },
    },
    Defect: {
      border: "1px solid #FFF1EB",
      fontSize: "15px",
      fontWeight: 600,
      width: "6rem",
      backgroundColor: "#FFF1EB",
      borderRadius: "10px",
      textTransform: "capitalize",
      color: "#FE7239",
      ":hover": {
        backgroundColor: "#FFF1EB",
      },
    },
    Repair: {
      border: "1px solid #FFE2E5",
      fontSize: "15px",
      fontWeight: 600,
      width: "6rem",
      backgroundColor: "#FFE2E5",
      borderRadius: "10px",
      textTransform: "capitalize",
      color: "#FF4646",
      ":hover": {
        backgroundColor: "#FFE2E5",
      },
    },
  };

  useEffect(() => {
    dispatch(
      getChecklistQuestionAnswerList({
        checklist_id: Props?.ChecklistRowData?.id,
      })
    );
  }, []);

  return (
    <Modal
      open={Props.isChecklistViewModel}
      onClose={() => Props.handleCloseChecklistViewModel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
            overflow: "",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "35px",
              }}
            >
              Checklist View
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{
                cursor: "pointer",
                width: "15px",
              }}
              onClick={Props.handleCloseChecklistViewModel}
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "25px 25px 25px 25px" }}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={1}
            spacing={{ xs: 1, sm: 2, md: 3 }}
            pb={3}
          >
            <Grid item xs={12} sm={6} md={3}>
              <Box
                sx={{
                  backgroundColor: "#F3F6F9",
                  padding: "15px",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography sx={labelstyle}>Checklist : </Typography>
                <Typography sx={inputStyle}>
                  {GenerateChecklistId(
                    Props?.ChecklistRowData?.vessel?.name,
                    Props?.ChecklistRowData?.checklist?.department?.name,
                    Props?.ChecklistRowData?.checklist?.checklist_type?.name,
                    Props?.ChecklistRowData.display_id
                  )}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box
                sx={{
                  backgroundColor: "#F3F6F9",
                  padding: "15px",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography sx={labelstyle}>Checklist Type : </Typography>
                <Typography sx={inputStyle}>
                  {Props?.ChecklistRowData?.checklist_type}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box
                sx={{
                  backgroundColor: "#F3F6F9",
                  padding: "15px",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography sx={labelstyle}>Department : </Typography>
                <Typography sx={inputStyle}>
                  {Props?.ChecklistRowData?.checklist?.department?.name}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box
                sx={{
                  backgroundColor: "#F3F6F9",
                  padding: "15px",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography sx={labelstyle}>Vessel Name : </Typography>
                <Typography sx={inputStyle}>
                  {Props?.ChecklistRowData?.vessel?.name}
                </Typography>
              </Box>
            </Grid>
            {/* <Grid item xs={12} md={6}>
              <Box
                sx={{
                  backgroundColor: "#F3F6F9",
                  padding: "15px",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography sx={labelstyle}>Created Date & Time : </Typography>
                <Typography sx={inputStyle}>
                  {moment(
                    Props?.ChecklistRowData?.checklist_created_date
                  ).format("D MMMM, YYYY | hh:mm A")}
                </Typography>
              </Box>
            </Grid> */}
            <Grid item xs={12} md={12}>
              <Box
                sx={{
                  backgroundColor: "#F3F6F9",
                  padding: "15px",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography sx={labelstyle}>Submitted Date & time :</Typography>
                <Typography sx={inputStyle}>
                  {moment(Props?.ChecklistRowData?.created_at)
                    .local()
                    .format("D MMMM, YYYY | hh:mm A")}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Divider />
          <Box
            sx={{
              display: "flex",
              padding: "20px 10px 20px 10px",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#B5B5C3",
                }}
              >
                Checklist Question
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 0,
                alignItems: "flex-start",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#B5B5C3",
                }}
              >
                Answer
              </Typography>
            </Box>
          </Box>
          <Divider />
          <Box pt={1}>
            <Grid
              sx={{
                overflow: "auto",
                height: "32rem",
                padding: "0px 10px 0px 10px",
                "&::-webkit-scrollbar": {
                  width: "5px",
                  height: "3px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#20724E",
                  borderRadius: "4px",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "#E5F1EB",
                },
              }}
            >
              {isLoading ? (
                <Grid item xs={12}>
                  <Stack
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      height: "32rem",
                    }}
                  >
                    <CircularProgress color="success" />
                  </Stack>
                </Grid>
              ) : (
                checklisQuestiontAnswerData?.map((row, index) => (
                  <Grid item xs={12} key={row?.id}>
                    <Stack direction="row" alignItems="center">
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                          // backgroundColor: "#F3F6F9",
                          // borderRadius: "10px",
                          padding: "10px 0px 0px 0px",
                          cursor: "pointer",
                        }}
                        // onClick={() => {
                        //   navigate(row?.path);
                        // }}
                      >
                        <Box sx={{ display: "flex" }}>
                          <Typography
                            align="center"
                            sx={{
                              fontSize: "14px",
                              color: "#464E5F",
                              fontWeight: 600,
                              paddingRight: "10px",
                            }}
                          >
                            Q{index + 1}:{" "}
                          </Typography>
                          <Typography
                            align="center"
                            sx={{
                              fontSize: "14px",
                              color: "#464E5F",
                              fontWeight: 600,
                            }}
                          >
                            {row?.question?.question}
                          </Typography>
                        </Box>
                        <Box>
                          <Button
                            sx={
                              row?.question?.defectReport
                                ? buttonStyles["Repair"]
                                : buttonStyles[row.answer]
                            }
                          >
                            {row?.question?.defectReport
                              ? "Defect"
                              : row.answer}
                            {/* {row.answer} */}
                          </Button>
                        </Box>
                      </Box>
                    </Stack>
                    <Divider sx={{ paddingTop: "10px" }} />
                  </Grid>
                ))
              )}
            </Grid>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ChecklistViewModel;
